import React from "react";

/**
 * Tarjeta base del sistema de UI (reutiliza .sw-pcard de theme-premium.css).
 * Uso:
 *   <Card>
 *     <Card.Header>Título</Card.Header>
 *     <Card.Body>...</Card.Body>
 *     <Card.Footer>...</Card.Footer>
 *   </Card>
 */
function Card({ className = "", children, ...rest }) {
  return (
    <div className={`sw-pcard ${className}`} {...rest}>
      {children}
    </div>
  );
}

Card.Header = function CardHeader({ className = "", children, ...rest }) {
  return (
    <div className={`sw-pcard-head ${className}`} {...rest}>
      {children}
    </div>
  );
};

Card.Body = function CardBody({ className = "", children, ...rest }) {
  return (
    <div className={`sw-pcard-body ${className}`} {...rest}>
      {children}
    </div>
  );
};

Card.Footer = function CardFooter({ className = "", children, ...rest }) {
  return (
    <div className={`sw-pcard-foot ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default Card;
